import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApiService } from "./base/api.service";
import { MarketplaceTradeListingSellDto } from "../dtos/marketplace-trade-listing.sell.dto";
import { MarketplaceTradeListingDto } from "../dtos/marketplace-trade-listing.dto";
import { MarketplaceTradeListingBuyDto } from "../dtos/marketplace-trade-listing.buy.dto";
import { MarketplaceTradeListingFilterDto } from "../dtos/marketplace-trade-listing.filter.dto";

@Injectable({
    providedIn: 'root',
})
export class MarketplaceTradeListingService {

    private readonly baseUrl = 'marketplacetradelisting/';

    constructor(private apiService: ApiService) { }

    create(creatureId: string, model: MarketplaceTradeListingSellDto): Observable<MarketplaceTradeListingDto> {
        return this.apiService.post<MarketplaceTradeListingDto>(this.baseUrl + creatureId, model);
    }

    delete(creatureId: string): Observable<MarketplaceTradeListingDto> {
        return this.apiService.delete<MarketplaceTradeListingDto>(this.baseUrl + creatureId);
    }

    purchaseListing(creatureId: string, model: MarketplaceTradeListingBuyDto): Observable<MarketplaceTradeListingDto> {
        return this.apiService.post<MarketplaceTradeListingDto>(this.baseUrl + creatureId + '/purchase', model);
    }

    getByFilter(model: MarketplaceTradeListingFilterDto): Observable<MarketplaceTradeListingDto[]> {
        return this.apiService.post<MarketplaceTradeListingDto[]>(this.baseUrl + 'filter', model);
    }
}